import { Button } from '@cian/ui-kit';

import * as styles from './styles.css';
import React from 'react';
import { getDeclension, useStuckState } from './utils';
import cn from 'clsx';
import { useSelector } from 'react-redux';
import { selectMasterButton } from '../../../selectors/landing';
import { ETestIds } from '../../../constants/testIds';
import { useTracking } from '../../../utils/tracking/useTracking';

export interface IScrollToOffersButtonProps {
  isLoading: boolean;
  offersCount: number | null;
}

export const ScrollToOffersButton: React.FC<IScrollToOffersButtonProps> = ({ isLoading, offersCount }) => {
  const { trackMobileShowButtonAmountOffers } = useTracking();
  const countWordForm = getDeclension(offersCount);
  const currentStickyButton = useSelector(selectMasterButton);
  const { stuck, buttonRef } = useStuckState();

  const onClickHandler = () => {
    const offerList = document.querySelector(`[data-testid=${ETestIds.OfferListContainer}]`);
    offerList?.scrollIntoView({
      behavior: 'smooth',
    });
    trackMobileShowButtonAmountOffers(offersCount);
  };

  return (
    <div
      ref={buttonRef}
      className={cn(
        styles['container'],
        stuck && styles['stuck'],
        currentStickyButton === 'showOffers' && styles['visible'],
      )}
    >
      <Button size="M" fullWidth loading={isLoading} data-testid={ETestIds.ShowOffersButton} onClick={onClickHandler}>
        Показать {countWordForm}
      </Button>
    </div>
  );
};
